import { render, staticRenderFns } from "./PhieuThuTienPhong.vue?vue&type=template&id=1f98374b&scoped=true&"
import script from "./PhieuThuTienPhong.vue?vue&type=script&lang=js&"
export * from "./PhieuThuTienPhong.vue?vue&type=script&lang=js&"
import style0 from "./PhieuThuTienPhong.vue?vue&type=style&index=0&id=1f98374b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98374b",
  null
  
)

export default component.exports